module.exports = __webpack_public_path__ + "img/icon_auswahl.d62c9e8.svg";